import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import useLocationQueryParams from './useLocationQueryParams';
import { fetchRouteDetail } from '../store/reducers/route';
import usePrevious from './usePrevious';
import { getRouteDetail } from '../store/selectors/route';
import { parseQuery, stringifyQuery } from '../utils/query';
import { clearStopFilters } from '../store/reducers/ui/filterPanel';

const useRouteChangeListener = (onRouteChangeCallBack) => {
  const { routeId, depot } = useLocationQueryParams();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const routeDetail = useSelector(getRouteDetail);
  const prevRouteId = usePrevious(routeId);
  const prevRouteDetails = usePrevious(routeDetail);

  useEffect(() => {
    if (routeDetail && prevRouteDetails?.routeId !== routeDetail.routeId) {
      onRouteChangeCallBack();
    }
  }, [onRouteChangeCallBack, prevRouteDetails, routeDetail]);

  useEffect(() => {
    if (routeId && routeId !== prevRouteId) {
      dispatch(fetchRouteDetail(depot, routeId)).catch(async () => {
        // eslint-disable-next-line no-unused-vars
        const { detailVisible, routeId, ...newQuery } = parseQuery(
          location.search
        );
        await navigate({
          search: stringifyQuery({ ...newQuery }),
        });
      });
    }
    dispatch(clearStopFilters());
  }, [depot, routeId, prevRouteId, dispatch, location.search, navigate]);
};

export default useRouteChangeListener;
